// import '@aytm/app/stats/page/styles/globals.scss'

import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsSunburst from 'highcharts/modules/sunburst'
import HighchartsTreemap from 'highcharts/modules/treemap'
import HighchartsTreegraph from 'highcharts/modules/treegraph'
import HighchartsExporting from 'highcharts/modules/exporting'

import '@aytm/app/stats/stores/skipperChatAssistants'

HighchartsMore(Highcharts)
HighchartsSunburst(Highcharts)
HighchartsTreemap(Highcharts)
HighchartsTreegraph(Highcharts)
HighchartsExporting(Highcharts)

import {
  cleanSearchData,
  getIsDefaultReportParams,
  getFilteredQuestions
} from '@aytm/app/stats/page/comments/lib/utils'

import { RenameAllCodebooks, RenameAllTags } from '@aytm/app/stats/page/sidebar/reports/actions'

import { GuidedReportStatusPoller } from '@aytm/app/stats/page/sidebar/reports/lib/skipperGuidedReportStatus'
import { registerDataQualityReportView } from '@aytm/app/stats/page/data-quality-report/controller/shim'

function renderComponent(props, element, path, component = 'default') {
  return new Promise((resolve, reject) => {
    if (null === element) {
      reject('element not specified')
      return
    }
    const React = require('react')
    const ReactDOM = require('react-dom')
    const reactEl = React.createElement(require(`@aytm/app/stats/page/${path}`)[component], props)
    resolve(ReactDOM.render(reactEl, element))
  })
}

export function renderDataView(name, { target, props, clear }) {
  switch (name) {
    case 'CompareItems': {
      return require('@aytm/app/stats/data-views/CompareItems').default({ target, props, clear })
    }
    default:
      return null
  }
}

export function updateDataView(name, component, props) {
  switch (name) {
    case 'CompareItems': {
      return require('@aytm/app/stats/data-views/CompareItems').update(component, props)
    }
    default:
      return false
  }
}

export function unlinkDataView(name, component) {
  switch (name) {
    case 'CompareItems': {
      return require('@aytm/app/stats/data-views/CompareItems').unlink(component)
    }
    default:
      return false
  }
}

export function renderSpecials(props, element) {
  return renderComponent(props, element, 'comments/index')
}

export function renderContentHeader(props, element) {
  return renderComponent(props, element, 'components/ContentHeader')
}

export function renderSkipperReportBanner(props, element) {
  return renderComponent(props, element, 'components/SkipperReportBanner')
}

export function renderReportsPanel(props, element) {
  return renderComponent(props, element, 'sidebar/reports/ReportsPanel')
}

export function renderSpecificationsPanel(props, element) {
  return renderComponent(props, element, 'sidebar/specifications/SpecificationsPanel')
}

export function renderColorOptionsPanel(props, element) {
  return renderComponent(props, element, 'sidebar/color-options/ColorOptionsPanel')
}

export function renderWeightingPanel(props, element) {
  return renderComponent(props, element, 'sidebar/weighting/WeightingPanel')
}

export function renderFiltersPanel(props, element) {
  return renderComponent(props, element, 'sidebar/filters/FiltersPanel')
}

export function renderDataQualityPanel(props, element) {
  return renderComponent(props, element, 'sidebar/data-quality/DataQualityPanel')
}

export function renderDataLabPanel(props, element) {
  return renderComponent(props, element, 'sidebar/data-lab/DataLabPanel')
}

export function renderMappingPanel(props, element) {
  return renderComponent(props, element, 'sidebar/mapping/MappingPanel')
}

export function renderCrosstabPanel(props, element) {
  return renderComponent(props, element, 'sidebar/crosstab/CrosstabPanel')
}

export function renderCodingPanel(props, element) {
  return renderComponent(props, element, 'sidebar/coding/CodingPanel')
}

export function renderViewOptionsPanel(props, element) {
  return renderComponent(props, element, 'sidebar/view-options/ViewOptionsPanel')
}

export function renderCompletesPanel(props, element) {
  return renderComponent(props, element, 'sidebar/completes/CompletesPanel')
}

export function renderExportSpecific(props, element) {
  return renderComponent(props, element, 'sidebar/export/ExportSpecific')
}

export function renderHeatMapPopup(props, element) {
  return renderComponent(props, element, 'question-views/hm/HeatMapPopup')
}

export function renderQuestionHeader(props, element) {
  return renderComponent(props, element, 'question-views/components/QuestionHeader')
}

export function renderTable(props, element) {
  return renderComponent(props, element, 'question-views/components/table/Table')
}

export function renderVQComponent(props, element) {
  return renderComponent(props, element, 'question-views/vq/Component')
}

export function renderCQComponent(props, element) {
  return renderComponent(props, element, 'question-views/cq/Component')
}

export function renderXQComponent(props, element) {
  return renderComponent(props, element, 'question-views/xq/Component')
}

export function renderCLComponent(props, element) {
  return renderComponent(props, element, 'question-views/cl/Component')
}

export function renderTLComponent(props, element) {
  return renderComponent(props, element, 'question-views/tl/Component')
}

export function renderSNComponent(props, element) {
  return renderComponent(props, element, 'question-views/sn/Component')
}

export function renderCLMappingComponent(props, element) {
  return renderComponent(props, element, 'question-views/cl-mapping/Component')
}

export function renderTLMappingComponent(props, element) {
  return renderComponent(props, element, 'question-views/tl-mapping/Component')
}

export function renderOEControls(props, element) {
  return renderComponent(props, element, 'question-views/oe/Controls')
}

export function renderCNControls(props, element) {
  return renderComponent(props, element, 'question-views/cn/Controls')
}

export function renderADControls(props, element) {
  return renderComponent(props, element, 'question-views/ad/Controls')
}

export function renderDCControls(props, element) {
  return renderComponent(props, element, 'question-views/data-cleaning/Controls')
}

export function renderItemsControls(props, element) {
  return renderComponent(props, element, 'question-views/components/items/Controls')
}

export function renderMNDeliveryFilter(props, element) {
  return renderComponent(props, element, 'question-views/mn/DeliveryControls')
}

export function renderMNMenuControls(props, element) {
  return renderComponent(props, element, 'question-views/mn/MenuMetricsControls')
}

export function renderMNSectionControls(props, element) {
  return renderComponent(props, element, 'question-views/mn/SectionMetricsControls')
}

export function renderMNProductControls(props, element) {
  return renderComponent(props, element, 'question-views/mn/ProductMetricsControls')
}

export function renderMNCommentsControls(props, element) {
  return renderComponent(props, element, 'question-views/mn/CommentsControls')
}

export function renderMNVerbatimView(props, element) {
  return renderComponent(props, element, 'question-views/mn/VerbatimView')
}

export function renderDCResponses(props, element) {
  return renderComponent(props, element, 'question-views/data-cleaning/Responses')
}

export function unlinkComponent(element) {
  return new Promise((resolve, reject) => {
    if (null === element) {
      reject('element not specified')
      return
    }
    const ReactDOM = require('react-dom')
    resolve(ReactDOM.unmountComponentAtNode(element))
  })
}

// Coffee-callable factory: builds (does not start) a guided-report status poller.
// reports_panel.coffee owns the start/stop lifecycle via its poller registry.
export function createGuidedReportStatusPoller(reportId, callbacks) {
  return new GuidedReportStatusPoller(reportId, callbacks)
}

export function initializeXpertsDebug() {
  return new Promise((resolve, _reject) => {
    const id = 'xperts-debug'
    let element = document.querySelector(`#${id}`)
    const exists = null !== element
    if (!exists) {
      element = document.createElement('div')
      element.id = id
      element.style.position = 'absolute'
      element.style.width = '100%'
      element.style.height = '80%'
      element.style.margin = '0 0 0 -100%'
      element.style.textAlign = 'left'
      element.style.zIndex = 1000
      document.querySelector('#page').appendChild(element)
    }
    if (element) {
      resolve(
        renderXpertsDebug({ text: 'Drop .json file here or click anywhere to open "File open..." dialog' }, element)
      )
    }
  })
}

export function renderXpertsDebug(props, element) {
  return renderComponent(props, element, 'xperts-debug/XpertsDebugPopup')
}

if ('undefined' != typeof window) {
  window['Highcharts'] = Highcharts

  window['$STATS'] || (window['$STATS'] = {})

  window['$STATS']['renderDataView'] = renderDataView
  window['$STATS']['updateDataView'] = updateDataView
  window['$STATS']['unlinkDataView'] = unlinkDataView

  window['$STATS']['renderSpecials'] = renderSpecials

  window['$STATS']['renderContentHeader'] = renderContentHeader

  window['$STATS']['renderSkipperReportBanner'] = renderSkipperReportBanner

  window['$STATS']['renderReportsPanel'] = renderReportsPanel
  window['$STATS']['createGuidedReportStatusPoller'] = createGuidedReportStatusPoller
  window['$STATS']['renderSpecificationsPanel'] = renderSpecificationsPanel
  window['$STATS']['renderColorOptionsPanel'] = renderColorOptionsPanel
  window['$STATS']['renderWeightingPanel'] = renderWeightingPanel
  window['$STATS']['renderFiltersPanel'] = renderFiltersPanel
  window['$STATS']['renderDataQualityPanel'] = renderDataQualityPanel
  window['$STATS']['renderDataLabPanel'] = renderDataLabPanel
  window['$STATS']['renderMappingPanel'] = renderMappingPanel
  window['$STATS']['renderCrosstabPanel'] = renderCrosstabPanel
  window['$STATS']['renderCodingPanel'] = renderCodingPanel
  window['$STATS']['renderViewOptionsPanel'] = renderViewOptionsPanel
  window['$STATS']['renderCompletesPanel'] = renderCompletesPanel

  window['$STATS']['renderExportSpecific'] = renderExportSpecific

  window['$STATS']['renderHeatMapPopup'] = renderHeatMapPopup

  window['$STATS']['renderQuestionHeader'] = renderQuestionHeader

  window['$STATS']['renderTable'] = renderTable

  window['$STATS']['renderVQComponent'] = renderVQComponent
  window['$STATS']['renderCQComponent'] = renderCQComponent
  window['$STATS']['renderXQComponent'] = renderXQComponent
  window['$STATS']['renderCLComponent'] = renderCLComponent
  window['$STATS']['renderTLComponent'] = renderTLComponent
  window['$STATS']['renderSNComponent'] = renderSNComponent

  window['$STATS']['renderCLMappingComponent'] = renderCLMappingComponent
  window['$STATS']['renderTLMappingComponent'] = renderTLMappingComponent

  window['$STATS']['renderCNControls'] = renderCNControls
  window['$STATS']['renderOEControls'] = renderOEControls
  window['$STATS']['renderDCControls'] = renderDCControls
  window['$STATS']['renderADControls'] = renderADControls

  window['$STATS']['renderItemsControls'] = renderItemsControls

  window['$STATS']['renderMNDeliveryFilter'] = renderMNDeliveryFilter
  window['$STATS']['renderMNMenuControls'] = renderMNMenuControls
  window['$STATS']['renderMNSectionControls'] = renderMNSectionControls
  window['$STATS']['renderMNProductControls'] = renderMNProductControls
  window['$STATS']['renderMNCommentsControls'] = renderMNCommentsControls
  window['$STATS']['renderMNVerbatimView'] = renderMNVerbatimView

  window['$STATS']['renderDCResponses'] = renderDCResponses

  window['$STATS']['unlinkComponent'] = unlinkComponent

  window['$STATS']['XpertsDebug'] = initializeXpertsDebug
  window['$STATS']['renderXpertsDebug'] = renderXpertsDebug

  window['$STATS']['RenameAllCodebooks'] = RenameAllCodebooks
  window['$STATS']['RenameAllTags'] = RenameAllTags

  window['$STATS']['cleanSearchData'] = cleanSearchData
  window['$STATS']['isSpecialsDefault'] = getIsDefaultReportParams
  window['$STATS']['getFilteredQuestions'] = getFilteredQuestions

  // Initialize ChatButton directly when $STATS is ready
  window['$STATS']['initChatButton'] = function () {
    if (window.$STATS?.skipperChatAssistants) {
      return window.$STATS.skipperChatAssistants.initialize()
    }
    return false
  }

  // Register the DQR bridge as page.classes.DataCentrifugeView
  // before page_router constructs it (page.classes uses ||= so order is safe).
  registerDataQualityReportView()
}
